<template>
    <div class="page-container" :class="{ collapsed: !$store.getters.sidebarOpened }">
        <div class="area-container left-area">
            <CommonTree
                type="room"
                :showFilter="true"
                @change="handleNodeClick"
                :customStyle="{ borderRight: 'none', width: '100%' }"
            />
        </div>
        <div class="data-container center-area">
            <div class="tool-box">
                <el-button type="primary" :icon="Refresh" @click="resetQueryForm">刷新</el-button>
                <el-button
                    type="primary"
                    plain
                    @click="temperatureCompensation(selected_ids, 0)"
                    v-permission="['pipeline-sensor:params-config:temperature-compensation']"
                >
                    温度补偿
                </el-button>
                <el-button
                    type="primary"
                    plain
                    @click="uploadCycle(selected_ids, 30)"
                    v-permission="['pipeline-sensor:params-config:report-cycle']"
                >
                    上传周期
                </el-button>
                <el-button
                    type="primary"
                    plain
                    @click="showPanel(selected_ids, true)"
                    v-permission="['pipeline-sensor:params-config:show-panel']"
                >
                    面板显示
                </el-button>
                <el-button
                    type="primary"
                    plain
                    @click="reportUrl(selected_ids, '')"
                    v-permission="['pipeline-sensor:params-config:report-url']"
                >
                    上报地址
                </el-button>
            </div>
            <el-form class="search-form" ref="search_form" :inline="true" :model="search_params" label-position="top">
                <el-form-item label="户名" prop="name">
                    <el-input style="width: 165px" v-model="search_params.name" clearable placeholder="请输入名称" />
                </el-form-item>
                <el-form-item label="状态" prop="online">
                    <el-select v-model="search_params.online" placeholder="请选择状态" style="width: 165px" clearable>
                        <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.name"
                            :value="Number(item.value)"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="IMEI" prop="IMEI">
                    <el-input style="width: 165px" placeholder="请输入IMEI" v-model="search_params.IMEI" clearable />
                </el-form-item>
                <el-form-item label="ICCID" prop="ICCID">
                    <el-input style="width: 165px" placeholder="请输入ICCID" v-model="search_params.ICCID" clearable />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :icon="Search" plain @click="getTableData">搜索</el-button>
                    <el-button :icon="Refresh" @click="resetQueryForm">重置</el-button>
                </el-form-item>
            </el-form>
            <el-table
                class="data-table"
                :data="table_data"
                v-loading="tableLoading"
                row-key="id"
                :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55" />
                <el-table-column label="户名" fixed="left" prop="name" width="130px" show-overflow-tooltip></el-table-column>
                <el-table-column label="安装位置" min-width="500" prop="location" show-overflow-tooltip>
                    <template #default="{ row }">
                        <span>{{ room_list[row.room] }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="温度补偿（℃）" width="90" prop="temperature_compensation">
                    <template #default="{ row }">
                        <span>{{ row.temperature_compensation ?? '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="上传周期（分钟）" width="90" prop="report_cycle">
                    <template #default="{ row }">
                        <span>{{ row.report_cycle ?? '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="面板显示" width="90" prop="show_panel">
                    <template #default="{ row }">
                        <el-tag v-if="row.show_panel" type="success">显示</el-tag>
                        <el-tag v-else type="info">不显示</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="上报地址" width="200" prop="udp_server_url"></el-table-column>
                <el-table-column label="IMEI" width="150px" prop="IMEI"></el-table-column>
                <el-table-column label="设备类型型号" width="220" prop="device_type">
                    <template #default="{ row }">
                        <span>{{ row.model ? model_list[row.model].type + '/' + model_list[row.model].model : '' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="260">
                    <template #default="{ row }">
                        <el-button
                            type="primary"
                            link
                            size="small"
                            @click="temperatureCompensation([row.id], row.temperature_compensation)"
                            v-permission="['pipeline-sensor:params-config:temperature-compensation']"
                        >
                            温度补偿
                        </el-button>
                        <el-button
                            type="primary"
                            link
                            size="small"
                            @click="uploadCycle([row.id], row.report_cycle)"
                            v-permission="['pipeline-sensor:params-config:report-cycle']"
                        >
                            上传周期
                        </el-button>
                        <el-button
                            type="primary"
                            link
                            size="small"
                            @click="showPanel([row.id], row.show_panel)"
                            v-permission="['pipeline-sensor:params-config:show-panel']"
                        >
                            面板显示
                        </el-button>
                        <el-button
                            type="primary"
                            link
                            size="small"
                            @click="reportUrl([row.id], row.udp_server_url)"
                            v-permission="['pipeline-sensor:params-config:report-url']"
                        >
                            上报地址
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination
                v-if="table_data.length > 0"
                :current-page="page_params.page"
                :page-size="page_params.page_size"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            ></Pagination>
        </div>
    </div>
</template>

<script setup>
import { h, onMounted, reactive, ref } from 'vue'
import { Refresh, Search } from '@element-plus/icons'
import { batchPatchParams, getDeviceList } from '@/api/heating/devicePoint/devicePoint.js'
import Pagination from '@/components/Pagination/index.vue'
import CommonTree from '@/components/BuildTree/CommonTree.vue'
import { getEquipModelTree } from '@/api/equipment.js'
import { getOptionTree } from '@/api/room.js'
import { ElInputNumber, ElMessage, ElMessageBox, ElSwitch } from 'element-plus'

// 型号列表
const model_list = ref({})
async function getModelList() {
    await getEquipModelTree().then((data) => {
        const list = {}
        data.forEach((device_type) => {
            device_type?.children &&
                device_type.children.forEach((device_model) => {
                    list[device_model.id] = {
                        type: device_type.name,
                        model: device_model.name
                    }
                })
        })
        model_list.value = list
    })
}

// 安装位置
const room_list = ref({})
async function getRoomTree() {
    await getOptionTree().then((data) => {
        const room_locations = {}
        function getRoom(list, location) {
            list.forEach((item) => {
                if (item.children) {
                    getRoom(item.children, location + '/' + item.name)
                } else {
                    room_locations[item.id] = location.slice(1) + '/' + item.name
                }
            })
        }
        getRoom(data ? data?.[0]?.children : [], '')
        room_list.value = room_locations
    })
}

// 状态列表
const statusList = [
    { name: '在线', value: 1 },
    { name: '离线', value: 0 }
]

// 左侧区域树
const current_node = ref({})
const handleNodeClick = (data) => {
    current_node.value = data
    resetQueryForm()
}

// 重置
const search_form = ref(null)
const resetQueryForm = () => {
    search_form.value.resetFields()
    getTableData()
}
// 数据源
const search_params = reactive({
    name: '',
    online: null,
    IMEI: '',
    ICCID: ''
})

const table_data = ref([])
const tableLoading = ref(true)
const total = ref(0)

// 获取列表数据
async function getTableData() {
    tableLoading.value = true
    const params = { ...search_params, ...page_params }
    if (current_node.value?.id) {
        if (current_node.value?.node_type !== undefined) {
            params.building = current_node.value.id
        } else {
            params.room = current_node.value.id
        }
    }
    params.type = 2
    getDeviceList(params).then((data) => {
        table_data.value = data.lists
        total.value = data.total
        tableLoading.value = false
    })
}

// 分页相关
const page_params = reactive({
    page: 1,
    page_size: 10
})
const handleSizeChange = (currentSize) => {
    page_params.page_size = currentSize
    page_params.page = 1
    getTableData()
}
const handleCurrentChange = (currentPage) => {
    page_params.page = currentPage
    getTableData()
}

// 表格项被勾选
const selected_ids = ref([])
function handleSelectionChange(rows) {
    selected_ids.value = rows.map((item) => item.id)
}

// 温度补偿
function temperatureCompensation(ids, value) {
    const checked = ref(value)
    ElMessageBox({
        title: '温度补偿值',
        message: () => {
            return h('div', {}, [
                h(ElInputNumber, {
                    modelValue: checked.value,
                    min: -50,
                    max: 50,
                    precision: 1,
                    step: 0.1,
                    'onUpdate:modelValue': (val) => {
                        checked.value = val
                    }
                }),
                h('span', ' ℃')
            ])
        },
        beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
                if (checked.value !== null) {
                    instance.confirmButtonLoading = true
                    batchPatchParams({
                        type: 2,
                        id_list: ids,
                        temp_compensation: checked.value
                    })
                        .then(() => {
                            instance.confirmButtonLoading = false
                            ElMessage.success('设置成功！')
                            getTableData()
                            done()
                        })
                        .catch(() => {
                            instance.confirmButtonLoading = false
                        })
                } else {
                    ElMessage.error('请输入温度补偿值')
                    instance.confirmButtonLoading = false
                }
            } else {
                done()
            }
        }
    })
}

// 上传周期
function uploadCycle(ids, value) {
    const checked = ref(value)
    const placeholder_value = ref('未知')
    ElMessageBox({
        title: '上传周期',
        message: () => {
            return h('div', {}, [
                h(ElInputNumber, {
                    modelValue: checked.value,
                    min: 1,
                    max: 2880,
                    'onUpdate:modelValue': (val) => {
                        checked.value = val
                        if (!val) {
                            placeholder_value.value = ''
                        }
                    },
                    placeholder: placeholder_value.value
                }),
                h('span', ' 分钟')
            ])
        },
        beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
                if (checked.value) {
                    instance.confirmButtonLoading = true
                    batchPatchParams({
                        type: 2,
                        id_list: ids,
                        report_cycle: checked.value
                    })
                        .then(() => {
                            instance.confirmButtonLoading = false
                            ElMessage.success('设置成功！')
                            getTableData()
                            done()
                        })
                        .catch(() => {
                            instance.confirmButtonLoading = false
                        })
                } else {
                    ElMessage.error('请输入上传周期')
                    instance.confirmButtonLoading = false
                }
            } else {
                done()
            }
        }
    })
}

// 面板显示
function showPanel(ids, value) {
    const checked = ref(value)
    ElMessageBox({
        title: '面板是否显示温湿度',
        message: () => {
            return h(ElSwitch, {
                modelValue: checked.value,
                activeText: '是',
                inactiveText: '否',
                'onUpdate:modelValue': (val) => {
                    checked.value = val
                }
            })
        },
        beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
                instance.confirmButtonLoading = true
                batchPatchParams({
                    type: 2,
                    id_list: ids,
                    show_panel: checked.value
                })
                    .then(() => {
                        instance.confirmButtonLoading = false
                        ElMessage.success('设置成功！')
                        getTableData()
                        done()
                    })
                    .catch(() => {
                        instance.confirmButtonLoading = false
                    })
            } else {
                done()
            }
        }
    })
}

// 上报地址
function reportUrl(ids, value) {
    ElMessageBox.prompt('请输入上报地址', '提示', {
        inputValue: value,
        inputPattern: /^(udp?:\/\/)?[\w-]+(\.[\w-]+)+:\d{1,5}\/?$/,
        inputErrorMessage: '请输入正确的上报地址',
        beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
                if (instance.inputValue !== null) {
                    instance.confirmButtonLoading = true
                    batchPatchParams({
                        type: 2,
                        id_list: ids,
                        udp_server_url: instance.inputValue
                    })
                        .then(() => {
                            instance.confirmButtonLoading = false
                            ElMessage.success('设置成功！')
                            getTableData()
                            done()
                        })
                        .catch(() => {
                            instance.confirmButtonLoading = false
                        })
                } else {
                    ElMessage.error('请输入上报地址')
                    instance.confirmButtonLoading = false
                }
            } else {
                done()
            }
        }
    })
}

// 切换到前台时候执行
onMounted(() => {
    getModelList()
    getRoomTree()
    getTableData()
})
</script>

<style scoped></style>
